// Question data with attachment style mappings
export const QUIZ_QUESTIONS = [
  {
    id: 1,
    text: "When someone you love pulls away or goes quiet, what happens inside you?",
    options: [
      { id: 'a', text: "I panic — I need to reach out, fix it, know we're okay", style: 'anxious' },
      { id: 'b', text: "I feel relieved, honestly. Distance is easier for me", style: 'avoidant' },
      { id: 'c', text: "Both — I desperately want to reach out AND I'm terrified of what I'll find", style: 'disorganized' },
      { id: 'd', text: "I give them space and trust we'll reconnect when they're ready", style: 'secure' }
    ]
  },
  {
    id: 2,
    text: "How do you typically handle your own emotional pain?",
    options: [
      { id: 'a', text: "I need to process it with someone — being alone with it feels unbearable", style: 'anxious' },
      { id: 'b', text: "I handle it privately. Showing vulnerability feels unsafe or weak", style: 'avoidant' },
      { id: 'c', text: "It depends — sometimes I reach out desperately, sometimes I completely shut down", style: 'disorganized' },
      { id: 'd', text: "I can sit with it myself and also reach out when I need support", style: 'secure' }
    ]
  },
  {
    id: 3,
    text: "In your relationship, which felt most true?",
    options: [
      { id: 'a', text: "I often worried I was too much, too needy — that they'd eventually leave", style: 'anxious' },
      { id: 'b', text: "I sometimes felt smothered, or like closeness made me want to pull back", style: 'avoidant' },
      { id: 'c', text: "I wanted closeness more than anything, but intimacy also scared me deeply", style: 'disorganized' },
      { id: 'd', text: "I generally felt secure in the relationship — the pain came from specific events, not constant worry", style: 'secure' }
    ]
  },
  {
    id: 4,
    text: "When you imagine being truly known by someone — all of you — what comes up?",
    options: [
      { id: 'a', text: "Longing. I want that more than anything", style: 'anxious' },
      { id: 'b', text: "Anxiety. What if they don't like what they see and leave?", style: 'avoidant' },
      { id: 'c', text: "Both the longing and the fear, at the same time, with equal force", style: 'disorganized' },
      { id: 'd', text: "Hope. I believe I'm worth knowing", style: 'secure' }
    ]
  }
];

// Result explanations
export const RESULT_EXPLANATIONS = {
  anxious: {
    title: "Anxious Attachment",
    color: "#A9756B",
    explanation: "You love deeply and you feel deeply — and that's not a flaw. Your nervous system learned early that love might disappear, so it stays alert to protect you. Sage will work with that pattern, not against it."
  },
  avoidant: {
    title: "Avoidant Attachment",
    color: "#72826F",
    explanation: "You built your strength in quiet — in not needing, not depending, not asking. That wasn't weakness; it was survival. Sage knows there's tenderness underneath the distance, and we'll get there gently."
  },
  disorganized: {
    title: "Disorganized Attachment",
    color: "#9f8a7d",
    explanation: "You carry two truths at once: the longing to be close, and the fear that closeness brings pain. That contradiction makes perfect sense given what you've been through. Sage will hold both with you."
  },
  secure: {
    title: "Secure Attachment",
    color: "#C9A84C",
    explanation: "You have a foundation of trust in yourself and others — even if this relationship shook it. Your capacity for secure connection is still there. Sage will help you return to it."
  }
};

// Calculate attachment style from answers
export const calculateAttachmentStyle = (answers) => {
  const counts = { anxious: 0, avoidant: 0, disorganized: 0, secure: 0 };
  answers.forEach(answer => {
    counts[answer]++;
  });
  
  let maxStyle = 'anxious';
  let maxCount = 0;
  
  Object.entries(counts).forEach(([style, count]) => {
    if (count > maxCount) {
      maxCount = count;
      maxStyle = style;
    }
  });
  
  return maxStyle;
};
